"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameStatus;
(function (GameStatus) {
    GameStatus["NotStarted"] = "NotStarted";
    GameStatus["InProgress"] = "InProgress";
    GameStatus["RaceOff"] = "RaceOff";
    GameStatus["Resulted"] = "Resulted";
})(GameStatus = exports.GameStatus || (exports.GameStatus = {}));
var ClockDirection;
(function (ClockDirection) {
    ClockDirection["Stopwatch"] = "Stopwatch";
    ClockDirection["Timer"] = "Timer";
})(ClockDirection = exports.ClockDirection || (exports.ClockDirection = {}));
var GamePart;
(function (GamePart) {
    GamePart["FirstOvertime"] = "FirstOvertime";
    GamePart["BreakAfterFirstOvertime"] = "BreakAfterFirstOvertime";
    GamePart["SecondOvertime"] = "SecondOvertime";
    GamePart["FirstSet"] = "FirstSet";
    GamePart["SecondSet"] = "SecondSet";
    GamePart["ThirdSet"] = "ThirdSet";
    GamePart["FourthSet"] = "FourthSet";
    GamePart["FifthSet"] = "FifthSet";
    GamePart["FirstPeriod"] = "FirstPeriod";
    GamePart["BreakAfterFirstPeriod"] = "BreakAfterFirstPeriod";
    GamePart["SecondPeriod"] = "SecondPeriod";
    GamePart["BreakAfterSecondPeriod"] = "BreakAfterSecondPeriod";
    GamePart["ThirdPeriod"] = "ThirdPeriod";
    GamePart["BreakAfterThirdPeriod"] = "BreakAfterThirdPeriod";
    GamePart["FirstQuarter"] = "FirstQuarter";
    GamePart["BreakAfterFirstQuarter"] = "BreakAfterFirstQuarter";
    GamePart["SecondQuarter"] = "SecondQuarter";
    GamePart["BreakAfterSecondQuarter"] = "BreakAfterSecondQuarter";
    GamePart["ThirdQuarter"] = "ThirdQuarter";
    GamePart["BreakAfterThirdQuarter"] = "BreakAfterThirdQuarter";
    GamePart["FourthQuarter"] = "FourthQuarter";
    GamePart["BreakAfterFourthQuarter"] = "BreakAfterFourthQuarter";
    GamePart["Overtime"] = "Overtime";
    GamePart["FirstHalf"] = "FirstHalf";
    GamePart["SecondHalf"] = "SecondHalf";
    GamePart["BreakAfterFirstHalf"] = "BreakAfterFirstHalf";
    GamePart["FirstInning"] = "FirstInning";
    GamePart["SecondInning"] = "SecondInning";
    GamePart["ThirdInning"] = "ThirdInning";
    GamePart["FourthInning"] = "FourthInning";
    GamePart["FifthInning"] = "FifthInning";
    GamePart["SixthInning"] = "SixthInning";
    GamePart["SeventhInning"] = "SeventhInning";
    GamePart["EighthInning"] = "EighthInning";
    GamePart["NinthInning"] = "NinthInning";
    GamePart["BreakAfterFirstInning"] = "BreakAfterFirstInning";
    GamePart["BreakAfterSecondInning"] = "BreakAfterSecondInning";
    GamePart["BreakAfterThirdInning"] = "BreakAfterThirdInning";
    GamePart["BreakAfterFourthInning"] = "BreakAfterFourthInning";
    GamePart["BreakAfterFifthInning"] = "BreakAfterFifthInning";
    GamePart["BreakAfterSixthInning"] = "BreakAfterSixthInning";
    GamePart["BreakAfterSeventhInning"] = "BreakAfterSeventhInning";
    GamePart["BreakAfterEighthInning"] = "BreakAfterEighthInning";
    GamePart["BreakAfterNinthInning"] = "BreakAfterNinthInning";
    GamePart["Finished"] = "Finished";
    GamePart["ExtraTime"] = "ExtraTime";
    GamePart["TenthInning"] = "TenthInning";
    GamePart["EleventhInning"] = "EleventhInning";
    GamePart["TwelfthInning"] = "TwelfthInning";
    GamePart["ThirteenthInning"] = "ThirteenthInning";
    GamePart["FourteenthInning"] = "FourteenthInning";
    GamePart["FifteenthInning"] = "FifteenthInning";
    GamePart["BreakAfterTenthInning"] = "BreakAfterTenthInning";
    GamePart["BreakAfterEleventhInning"] = "BreakAfterEleventhInning";
    GamePart["BreakAfterTwelfthInning"] = "BreakAfterTwelfthInning";
    GamePart["BreakAfterThirteenthInning"] = "BreakAfterThirteenthInning";
    GamePart["BreakAfterFourteenthInning"] = "BreakAfterFourteenthInning";
    GamePart["BreakAfterFifteenthInning"] = "BreakAfterFifteenthInning";
})(GamePart = exports.GamePart || (exports.GamePart = {}));
//# sourceMappingURL=event.js.map